import { render, staticRenderFns } from "./ApplicationsUser.vue?vue&type=template&id=a4e8b0ba"
import script from "./ApplicationsUser.vue?vue&type=script&lang=js"
export * from "./ApplicationsUser.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsUser.vue?vue&type=style&index=0&id=a4e8b0ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports